export default function countryReducer(state = { countryState: [] }, action) {
    switch (action.type) {
        case 'COUNTRY_STATE':
            return {
                countryState: action.countryState
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducer/countryreducer.jsx